import { categories } from "@/mocks/comics";

interface CategoriesProps {
  onSelect: (category: string) => void;
}

export default function Categories({ onSelect }: CategoriesProps) {
  const handle = (name: string) => {
    onSelect(name);
    document.getElementById("featured")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="categories" className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="text-sm font-semibold text-primary-600">按题材找漫</p>
          <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-3xl">八大热门题材</h2>
        </div>
        <p className="max-w-md text-sm text-foreground-600">
          不管你想看软萌日常，还是高甜恋爱，都能在这里快速定位到喜欢的作品。
        </p>
      </div>

      <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
        {categories.map((c) => (
          <button
            key={c.name}
            type="button"
            onClick={() => handle(c.name)}
            className="group flex items-center gap-4 rounded-lg bg-background-100 p-4 text-left transition-colors hover:bg-primary-100"
          >
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-primary-500 text-xl text-background-50 transition-transform group-hover:scale-105">
              <i className={c.icon} aria-hidden="true"></i>
            </span>
            <span className="min-w-0">
              <span className="block truncate text-sm font-semibold text-foreground-950">{c.name}</span>
              <span className="mt-0.5 block truncate text-xs text-foreground-600">{c.desc}</span>
              <span className="mt-1 block text-xs text-primary-600">{c.count} 部作品</span>
            </span>
          </button>
        ))}
      </div>
    </section>
  );
}